import { ERROR_CODES, VALIDATION_ERROR_CODES } from '../constants'
import { isArray, isEmpty, isPlainObject,has } from 'lodash'
import { convertToSnakeCase } from './ObjectHelpers'

export class ForbiddenError extends Error {
}

export class PermissionDeniedError extends ForbiddenError {
  constructor (message) {
    super(message)
    this.name = 'PermissionDenied'
  }
}

export class AuthenticationError extends ForbiddenError {
  constructor (message) {
    super(message)
    this.name = 'AuthenticationError'
  }
}

export const formatFormError = (fields, data) => {
  let errors = {}

  if (!isPlainObject(data)) {
    return;
  }

    Object.keys(data).forEach((fieldName) => {
      if (isArray(data[fieldName])) {
        data[fieldName].forEach((obj) => {
          if (isPlainObject(obj) && Object.keys(obj).every(key => !isArray(obj[key]))) {
            errors = Object.assign(errors, getErrorMsg(fields, fieldName, obj.code, obj.message))
          } else if (isPlainObject(errors) && fieldName in errors) {
            errors[fieldName].push(formatFormError(obj))
          } else {
            errors[fieldName] = [formatFormError(obj)]
          }
        })
      } else if (isPlainObject(data[fieldName]) && isEmpty(data[fieldName])) {
        errors[fieldName] = [formatFormError(data[fieldName])]
      }
    })
  
  return errors
}

const getErrorMsg = (fields, fieldName, code, message) => {
  const errors = {}
  if (fieldName === 'nonFieldErrors') {
    fields.forEach((field) => {
      if (message.includes(convertToSnakeCase(field.name))) {
        errors[field.name] = VALIDATION_ERROR_CODES[code] || 'ERROR.CODE.VALIDATION.INVALID'
      }
    })
  } else {
    errors[fieldName] = VALIDATION_ERROR_CODES[code] || 'ERROR.CODE.VALIDATION.INVALID'
  }
  return errors
}

export const formatErrorMessage = (error) => {
  const { statusCode, data = {},status = undefined} = error
  console.log(data);
  const { errorCode = undefined } = data

  if (statusCode === 400 && errorCode && !data.includes("Invalid height metric") && !data.includes("Invalid perimeter metric")) {
    return 'ERROR.CODE.FORM_FAILED'
  }
  else if ( status === 400 && (data.includes("Wrong password."))) {
    return "AUTH.FORGOT.ERROR" 
  }
  else if ( statusCode === 400 && (data.includes("Invalid height metric") || data.includes("Invalid perimeter metric"))) {
    return "MEDICAL.FOLDER.ERROR"
  }
    else if ( data.includes("You have to vaccinate the previous vaccinations.")) {
    return "VACCINATION.ANTIRAB.PREVIOUS.ERROR"
  }
  else if ( data.includes("La date de vaccination doit être égale à aujourd’hui pour ce type de protocole.")) {
    return "VACCINATION.ANTIRABIES.ERROR.VACCINATION_DATE_MUST_BE_TODAY"
  }
  else if ( data.includes("Date d'agression de la fiche manquante.")) {
    return "VACCINATION.ANTIRABIES.ERROR.MISSING_FICHE_ATTACK_DATE"
  }
  else if ( data.includes("La date doit être comprise entre la date d'agression et hier.")) {
    return "VACCINATION.ANTIRABIES.ERROR.DATE_OUT_OF_RANGE"
  }
  else if ( status === 400 && (data.includes("File size exceeds the limit."))) {
    return "ERROR.INVALID_FILE_SIZE"
  }
  else if ( status === 400 &&(data.includes("Invalid PDF content.")||data.includes("Invalid file type.") || data.includes("Invalid image content."))) {
    return "ERROR.INVALID_FILE"
  }
  else if ( status === 400 && (data.includes("JO doit etre fait"))) {
    return "ERROR.FIRST_DOSE_VACCINATION_NEEDED"
  }
  else if ( status === 400 && (data.includes("sheet not fount"))) {
    return "ERROR.SHEET_NOT_FUND"
  }
  else if ( status === 400 && (data.includes("PR cannot be updated"))) {
    return "ERROR.PR_CANNOT_BE_UPDATED"
  }
  else if ( status === 400 && (data.includes("update only etat_animal_j0_j7"))) {
    return "ERROR.UPDATE_ONLY_ETAT_ANIMAL_J0_J7"
  }
  else if ( status === 400 && (data.includes("update only etat_animal_j7_j14"))) {
    return "ERROR.UPDATE_ONLY_ETAT_ANIMAL_J7_J14"
  }
  else if ( status === 400 && (data.includes("J3 non fait"))) {
    return "ERROR.J3_NON_FAIT"
  }
  else if ( status === 400 && (data.includes("sheet A1 open more than 14days"))) {
    return "ERROR.SHEET_A1_OPEN_MORE_THAN_14DAYS"
  }
  else if ( status === 400 && (data.includes("sheet A2 open more than 14days"))) {
    return "ERROR.SHEET_A2_OPEN_MORE_THAN_14DAYS"
  }
  else if ( status === 400 && (data.includes("date: must be today"))) {
    return "ERROR.MUST.BE_TODAY"
  }
  else if ( status === 400 && (data.includes("date: cannot be in the future"))) {
    return "ERROR.CANNOT_BE_IN_THE_FUTURE"
  }
  else if ( status === 400 && (data.includes("date: should be in the future"))) {
    return "ERROR.SHOULD_BE_IN_THE_FUTURE"
  }
  else if ( status === 400 && (data.includes("{'Date must be today'}"))) {
    return "ERROR.MUST.BE_TODAY"
  }
  else if ( status === 400 && (data.includes("date_agression must be between the original date and today"))) {
    return "VACCINATION.ANTIRABIES.DATE_AGRESSION_RANGE_ERROR"
  }
  else if ( status === 400 && (data.includes("second aggressions required"))) {
    return "VACCINATION.ANTIRABIES.SECOND_AGGRESSION_REQUIRED"
  }
  else if ( status === 504 && (data.includes("The request timed out"))) {
    return "Backend service request timed out"
  }
  else if ( status === 404 && (data.includes("citizen not found"))) {
    return "AUTH.FORGOT.ERROR"
  }
  else if ( status === 404 && (data.includes("child not found"))) {
    return "parent not found"
  }
  else if ( status === 400 && (data.includes("Phone number not available"))) {
    return "Phone number not available"
  }
  else if ( status === 400 && (data.includes("Les vaccins sont redondante"))) {
    return "VACCIN.REDONDANT"
  }
  else if ( status === 400 && (data.includes("Le vaccin est déjà enregistré pour cet identifiant de santé avec durée de validité à vie."))) {
    return "VACCIN.ALREADY_REGISTERED"
  }
  else if ( status === 400 && (data.includes("Le vaccin est encore valide jusqu'au futur pour cet identifiant de santé."))) {
    return "VACCIN.VALID_UNTIL_FUTURE"
  }
  else if ( status === 400 && (data.includes("Child not found or already validated"))) {
    return "INS_VALIDATION_ERROR"
  }
  else if ( status === 404 && (data.includes("Child not found or already validated"))) {
    return "INS_VALIDATION_ERROR"
  }
  else if ( status === 404 && (data.includes("No result found for given matricule_naissance"))) {
    return "INS_VALIDTION_ERROR1"
  }
  else if ( status === 400 && (data.includes("No result found for given matricule_naissance"))) {
    return "INS_VALIDTION_ERROR1"
  }
  else if ( status === 404 && (data.includes("Matricule de naissance must be a numeric string of exactly 10 digits"))) {
    return "INS_VALIDTION_ERROR2"
  }
  else if ( status === 400 && (data.includes("Matricule de naissance must be a numeric string of exactly 10 digits"))) {
    return "INS_VALIDTION_ERROR2"
  }
  else if ( status === 400 && (data.includes("EXTERNAL_SERVICE_ERROR: Please contact support if the problem persists"))) {
    return "INS_VALIDTION_ERROR3"
  }
  else if ( status === 500 ) {
    return "ERROR.CODE.INTERNAL_ERROR"
  }
  return ERROR_CODES[(errorCode || statusCode)] || 'ERROR.CODE.INTERNAL_ERROR'
}


export const formatMessageError = (error) => {
  if (!error) return 
  if (!error.response) return
  const {response:{data}} = error 
  if (has(data,"error")){
    return error.response.data.error;
  }
  else if (has(data,"detail")) {
    return error.response.data.detail;
  }
  else {
    return error.response.data
  }
}